/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsCurrencyExchangeNoticeViewProps } from './lds-currency-exchange-notice';
//@ts-ignore
import { Info } from '@churchofjesuschrist/eden-alert';
import { getCartState } from '@msdyn365-commerce/global-state';
import { getCountryLanguageAsync } from '../../actions/DataActionExtension.g';
import { format } from '@msdyn365-commerce-modules/utilities';

export default (props: ILdsCurrencyExchangeNoticeViewProps) => {
    const [cart, setCart] = React.useState<any>();
    const [countries, setCountries] = React.useState<any>();
    const getCart = async () => {
        const cart = await getCartState(props.context.actionContext);
        setCart(cart);
        return cart;
    };
    const getCurrecy = async () => {
        const ctx = { callerContext: props.context.actionContext };
        // const countries = await getCountryLanguageAsync(ctx, props.context.actionContext.requestContext.channel!.RecordId, 'en-us');
        const countries = await getCountryLanguageAsync(ctx, 5637181326, 'en-us');
        setCountries(countries);
        return countries;
    };

    React.useEffect(() => {
        void getCart();
        void getCurrecy();
    }, []);
    let currentCountry: any;
    if (cart && cart.cart && cart.cart.ExtensionProperties) {
        currentCountry = cart.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value?.StringValue;
    }
    let countryData;
    if (countries && countries.length > 1) {
        countryData = countries.filter((country: any) => {
            return country.countryRegionId === currentCountry;
        });
    }
    let shouldShowCurrencyMessage = false;
    if (countryData && countryData[0]) {
        shouldShowCurrencyMessage =
            //@ts-ignore
            countryData[0].ExtensionProperties[7].Value?.StringValue === countryData[0].ExtensionProperties[8].Value?.StringValue
                ? false
                : true;
    }

    if (shouldShowCurrencyMessage) {
        return (
            <div className='row'>
                <Info>
                    <div style={{ paddingTop: '3px', fontSize: '18px' }}>
                        {/* @ts-ignore */}
                        {format(props.resources.currencyFeeMessage, props.context.cultureFormatter.currencyCode)}
                    </div>
                </Info>
            </div>
        );
    } else {
        return <></>;
    }
};
